/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function HandsClapping(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M190.251,69.68652a23.9764,23.9764,0,0,0-41.56055.01514L133.07422,42.65332a23.97141,23.97141,0,0,0-41.8042.45459A24.00171,24.00171,0,0,0,49.90137,64.916a23.98424,23.98424,0,0,0-17.28614,35.7373L36.23,106.91455A23.98051,23.98051,0,0,0,15.4375,142.90234l37,64.08594a77.99184,77.99184,0,0,0,140.75391-12.09082A78.372,78.372,0,0,0,207.251,99.13184Zm-37.2627,155.459a66.077,66.077,0,0,1-90.1582-24.15723l-37-64.08594a12.00023,12.00023,0,0,1,20.78515-12l.001.00122,23.999,41.56812a6.00012,6.00012,0,1,0,10.39258-6l-38-65.81836a11.99981,11.99981,0,1,1,20.78418-12l38,65.81836a6.00012,6.00012,0,0,0,10.39258-6l-30-51.96143v-.00048a11.99981,11.99981,0,1,1,20.78418-12l42,72.74609a6.00012,6.00012,0,0,0,10.39258-6L139.36182,117.5437l-.00049-.00073a11.99981,11.99981,0,0,1,20.78418-12l17,29.44531a65.999,65.999,0,0,1-24.15723,90.15723Zm13.9209-199.97266,4.1416-15.4541a6.00029,6.00029,0,0,1,11.5918,3.10547l-4.1416,15.4541a6.00029,6.00029,0,0,1-11.5918-3.10547Zm26.06152,9.85352,9.17774-13.10645a6.00007,6.00007,0,0,1,9.83008,6.88281l-9.17774,13.10645a6.00007,6.00007,0,0,1-9.83008-6.88281Zm41.10938,18.82519L220.97363,63.0293a6.00007,6.00007,0,0,1-6.88281-9.83008l13.10645-9.17774a6.00007,6.00007,0,0,1,6.88281,9.83008Z" />
    </Svg>
  );
}

export default HandsClapping;
